import Fingerprint from "@fingerprint/agent";
import { FINGERPRINT_ENDPOINT, FINGERPRINT_KEY, USER_ID } from "../constants";

export default () => ({
  requestId: null,

  async init() {
    if (!FINGERPRINT_KEY) {
      return;
    }

    try {
      const agent = Fingerprint.start({
        apiKey: FINGERPRINT_KEY,
        // Route identification through our first-party subdomain to evade ad
        // blockers; the SDK falls back to its default endpoint when unset.
        ...(FINGERPRINT_ENDPOINT && { endpoints: FINGERPRINT_ENDPOINT }),
      });

      const result = await agent.get({ linkedId: USER_ID });

      this.requestId = result.event_id;
    } catch {
      // Identification failed (adblock, timeout, network). Submit without it.
    }
  },
});
